export default "__VITE_ASSET__8iMVTUYQ__"